<app-header  ></app-header>
<app-sidebar ></app-sidebar>
<section class="main-container" >
  
          <router-outlet></router-outlet>
 
</section>